/* =========================================================================
   Gutsi - drives the "See what our beta users love" marquee on DESKTOP.

   The section (sections/g-sec-review.liquid) renders the review set three
   times and then wraps its entire init in `if (isMobile) { ... }` with no
   else, so on desktop the carousel is never initialised and simply sits at
   scrollLeft 0 forever. This file supplies the missing half. It deliberately
   does NOT touch mobile - the section's own code already handles that path,
   and running both would double-scroll.

   rAF IS CORRECT HERE, unlike in claude-ticker.js / claude-hero.js. This is a
   continuous animation, so pausing while the tab is hidden is the desired
   behaviour rather than a bug. The one hazard is the timestamp gap when the
   tab comes back - a delta of several minutes would teleport the strip - so
   any frame longer than 100ms is discarded rather than integrated.

   Loop: scroll until one full track plus one gap has passed, then subtract
   that distance. Because the following track is an identical copy, the strip
   is pixel-identical either side of the jump and the seam is invisible.
   ========================================================================= */
(function () {
  'use strict';

  var MOBILE_MAX = 768;
  var MAX_FRAME_MS = 100;

  function boot() {
    var carousel = document.querySelector('.gutsi-reviews-carousel');
    if (!carousel) return;

    var track = carousel.querySelector('.gutsi-reviews-track');
    if (!track) return;

    if (carousel.dataset.autoScroll !== 'true') return;

    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    /* Same units as the section's mobile path: `speed` pixels per 60fps
       frame, i.e. speed x 60 px per second. */
    var speed = parseFloat(carousel.dataset.scrollSpeed) || 1;
    var pxPerSecond = speed * 60;

    var running = false;
    var paused = false;
    var rafId = null;
    var lastTs = 0;
    var position = 0;
    var loopDistance = 0;

    function gapPx() {
      var g = parseFloat(getComputedStyle(carousel).columnGap);
      if (isNaN(g)) g = parseFloat(carousel.dataset.cardGap) || 30;
      return g;
    }

    function measure() {
      loopDistance = track.offsetWidth + gapPx();
    }

    function frame(ts) {
      if (!running) return;
      if (!lastTs) lastTs = ts;
      var delta = ts - lastTs;
      lastTs = ts;

      /* Discard the huge delta produced by a backgrounded tab. */
      if (delta > MAX_FRAME_MS) delta = 0;

      if (!paused && loopDistance > 0) {
        position += (pxPerSecond * delta) / 1000;
        while (position >= loopDistance) position -= loopDistance;
        carousel.scrollLeft = position;
      }

      rafId = window.requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      measure();
      if (loopDistance <= 0) return;
      running = true;
      lastTs = 0;
      carousel.classList.add('is-marquee');
      rafId = window.requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = null;
      carousel.classList.remove('is-marquee');
      carousel.scrollLeft = 0;
      position = 0;
    }

    function syncToViewport() {
      if (window.innerWidth > MOBILE_MAX) {
        start();
        measure();
      } else {
        /* Below this the section's own script owns the carousel. */
        stop();
      }
    }

    carousel.addEventListener('mouseenter', function () { paused = true; });
    carousel.addEventListener('mouseleave', function () { paused = false; });
    /* Keyboard users tabbing into a card should not have it slide away. */
    carousel.addEventListener('focusin', function () { paused = true; });
    carousel.addEventListener('focusout', function () { paused = false; });

    window.addEventListener('resize', syncToViewport);
    window.addEventListener('load', function () { measure(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(function () {});
    }

    syncToViewport();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
